import { render } from "./PlayerOverview.vue?vue&type=template&id=cae1d2cc&scoped=true"
import script from "./PlayerOverview.vue?vue&type=script&lang=js"
export * from "./PlayerOverview.vue?vue&type=script&lang=js"

import "./PlayerOverview.vue?vue&type=style&index=0&id=cae1d2cc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cae1d2cc"]])

export default __exports__